@if (format) {
  <div class="layout-col gap-sm full">
    @if (format.padding !== 0) {
      <mat-form-field class="flex">
        <mat-label>{{ 'numberSequences.numberPadding' | translate }}</mat-label>
        <input
          matInput
          type="number"
          name="padding"
          required
          readonly
          placeholder="{{ 'numberSequences.numberPadding' | translate }}"
          [min]="0"
          [max]="16"
          [(ngModel)]="format.padding"
        />
        <mat-hint align="end">{{
          'numberSequences.numberPaddingDescription' | translate
        }}</mat-hint>
      </mat-form-field>
    }
    @if (format.takeFirst !== 0) {
      <mat-form-field class="flex">
        <mat-label>{{ 'numberSequences.takeFirst' | translate }}</mat-label>
        <input
          matInput
          type="number"
          name="takeFirst"
          required
          readonly
          placeholder="{{ 'numberSequences.takeFirst' | translate }}"
          [min]="0"
          [max]="16"
          [(ngModel)]="format.takeFirst"
        />
        <mat-hint align="end">{{ 'numberSequences.takeFirstDescription' | translate }}</mat-hint>
      </mat-form-field>
    }
    @if (format.takeLast !== 0) {
      <mat-form-field class="flex">
        <mat-label>{{ 'numberSequences.takeLast' | translate }}</mat-label>
        <input
          matInput
          type="number"
          name="takeLast"
          required
          readonly
          placeholder="{{ 'numberSequences.takeLast' | translate }}"
          [min]="0"
          [max]="16"
          [(ngModel)]="format.takeLast"
        />
        <mat-hint align="end">{{ 'numberSequences.takeLastDescription' | translate }}</mat-hint>
      </mat-form-field>
    }
    @if (format.dropFirst !== 0) {
      <mat-form-field class="flex">
        <mat-label>{{ 'numberSequences.dropFirst' | translate }}</mat-label>
        <input
          matInput
          type="number"
          name="dropFirst"
          required
          readonly
          placeholder="{{ 'numberSequences.dropFirst' | translate }}"
          [min]="0"
          [max]="16"
          [(ngModel)]="format.dropFirst"
        />
        <mat-hint align="end">{{ 'numberSequences.dropFirstDescription' | translate }}</mat-hint>
      </mat-form-field>
    }
    @if (format.dropLast !== 0) {
      <mat-form-field class="flex">
        <mat-label>{{ 'numberSequences.dropLast' | translate }}</mat-label>
        <input
          matInput
          type="number"
          name="dropLast"
          required
          readonly
          placeholder="{{ 'numberSequences.dropLast' | translate }}"
          [min]="0"
          [max]="16"
          [(ngModel)]="format.dropLast"
        />
        <mat-hint align="end">{{ 'Number of characters dropped at the end' }}</mat-hint>
      </mat-form-field>
    }
    @if (format.trimLeading) {
      <mat-form-field class="flex">
        <mat-label>{{ 'numberSequences.trimLeading' | translate }}</mat-label>
        <input
          matInput
          type="text"
          name="trimLeading"
          required
          readonly
          placeholder="{{ 'numberSequences.trimLeading' | translate }}"
          [min]="0"
          [max]="16"
          [(ngModel)]="format.dropLast"
        />
        <mat-hint align="end">{{ 'Characters trimmed from the beginning' }}</mat-hint>
      </mat-form-field>
    }
  </div>
}
